// extracted by mini-css-extract-plugin
export var sliderRange = "_ns-2";
export var sliderRoot = "_ns-0";
export var sliderThumb = "_ns-3";
export var sliderTrack = "_ns-1";